import { FeatureFlag } from '../FeatureFlag';

export const enableCommandPalette = new FeatureFlag({
    key: 'enable-command-palette',
    defaultValue: false,
});
